import type { FlightRecord } from "./types";

/**
 * Match a plane's callsign to a row in the loaded flights list.
 *
 * Exact match only — both `flight_iata` and `flight_icao` are checked.
 * The previous fallback ran a `endsWith(call.replace(/^[A-Z]+/, ""))`
 * fuzzy match that stripped the airline prefix and matched on trailing
 * digits, which produced wildly wrong matches: clicking ANA85 would
 * match the unrelated ANA5985 (same trailing "85") and the detail card
 * would render that flight's codeshare partner. Showing nothing is
 * better than showing a misleading row.
 */
export function findFlight(call: string | null, flights: FlightRecord[]): FlightRecord | null {
  if (!call) return null;
  return flights.find((f) => f.flight_iata === call || f.flight_icao === call) ?? null;
}
